import CalendarView from '../Calendar'
import EventMap from '../../Components/EventMap';

export default class Month extends CalendarView {
    constructor(calendar, identifier) {
        super(calendar, identifier)
        this.unit = 'day'
        this.majorUnit = 'month'
        this.viewName = 'month'
    }

    get unit() {
        return this._unit
    }

    set unit(unit) {
        if (unit !== 'day') {
            throw Error('Cant change the unit on the Month View!')
        }
        this._unit = unit
    }

    get majorUnit() {
        return this._majorUnit
    }

    set majorUnit(majorUnit) {
        if (majorUnit !== 'month') {
            throw Error('Cant change the majorUnit on the Month View!')
        }
        this._majorUnit = majorUnit
    }

    // Overwrite endDate.  for this view, only the start date can be set
    get endDate() {
        return this.startDate.clone().endOf('month')
    }

    set endDate(endDate) {
        // do nothing for this view
    }

    addToDOM() {
        // Build the eventMap, creates the container div, adds calendar controls
        if (!this.unit) {
            this.unit = 'day'
        }
        if (this.startDate === undefined) {
            this.setStartDateToDefault()
        }
        this.state.eventMap = new EventMap(this.getEventMapKeyFormat(), this.calendar.events);
        this.view.append(this.getControls())
        // add Month View specific html
        const calendarMonth = document.createElement('div')
        calendarMonth.className = 'whale-calendar-month'

        this.view.append(calendarMonth)
        this.render()

        this.view.append(this.editModal.view)
    }

    render() {
        const calendarMonth = this.view.querySelector('.whale-calendar-month')
        calendarMonth.innerHTML = ''
        const startDate = this.startDate
        const monthStartDate = startDate.clone().startOf('month')
        const monthEndDate = monthStartDate.clone().endOf('month')          
        let date = monthStartDate.clone()
        const nowDateKey = this.state.eventMap.getKeyFromMoment(moment())

        // Build Month Structure
        // Table Header with days of the week
        date = date.startOf('week')
        let days = date.clone()

        const monthContainer = document.createElement('div')
        monthContainer.className = 'whale-month-container'

        const monthHeader = document.createElement('div')
        monthHeader.className = 'whale-major-unit-header whale-table-header-group'
        for (let i = 0; i < 7; i++) {
            const dayColumnHeader = document.createElement('div')
            dayColumnHeader.className = 'whale-day-column-header whale-table-cell' 
            dayColumnHeader.textContent = days.days(i).format('dddd')
            monthHeader.append(dayColumnHeader)
        }
        monthContainer.append(monthHeader)
        calendarMonth.append(monthContainer)

        const monthTableBody = document.createElement('div') 
        monthTableBody.className = 'whale-table-body'
        monthContainer.append(monthTableBody)
        while (date < monthEndDate) {
            // Build Week Structure Sun-Sat
            const weekRow = document.createElement('div')
            weekRow.className = 'whale-month-week-row whale-table-row'
            monthTableBody.append(weekRow)

            const weekEnd = date.clone().endOf('week')
            while (date < weekEnd) {
                // Build Day structure
                const key = this.state.eventMap.getKeyFromMoment(date)
                // Contains one unit of time
                const dayCol = document.createElement('div')
                dayCol.className = 'whale-month-day-col whale-table-cell'
                if (key === nowDateKey) {
                    dayCol.classList.add('today')
                }
                if (date < monthStartDate || date > monthEndDate) {
                    dayCol.classList.add('out-of-scope')
                }
                weekRow.append(dayCol)

                const flexContainer = document.createElement('div')
                flexContainer.className = 'flex-container'
                dayCol.append(flexContainer)

                const dateHeaderSpan = document.createElement('span')
                dateHeaderSpan.className = 'whale-table-cell-header'
                dateHeaderSpan.textContent = date.format('D')
                flexContainer.append(dateHeaderSpan)

                const eventsCol = document.createElement('div')
                eventsCol.className = 'whale-events-col whale-events-droppable'
                eventsCol.setAttribute('data-date-key', key)
                flexContainer.append(eventsCol)
                this.updateUiForDateKey(key)
                date.add(1, 'day')
            }
        }
        this.addEventListeners()
    }

    updateAllEvents() {
        const date = this.startDate.startOf('month').startOf('week')
        const end = this.endDate.endOf('week')
        while (date <= end) {
            this.updateUiForDateKey(this.state.eventMap.getKeyFromMoment(date))
            date.add(1, 'day')
        }
    }
}